export default "__VITE_ASSET__e4LvQqdY__"